import { useMemo } from 'react'

import { ScrollArea } from '@circlefin/components'
import { usePermission } from '@circlefin/permissions/react'
import { LEGACY_APPROVAL_WORKFLOW_MUTATION } from '@services/permissions'
import { approvalSettingsSection } from '@services/sections/lib/approvalSettings'
import {
  delayedWithdrawalsSection,
  fraudManagement,
  ipAllowListingSection,
  legacyAdminApprovalsSection,
  loginAndSecuritySection,
} from '@services/sections/lib/settings'

import { MainNav } from '../../MainNav/MainNav'

import { groups } from './SettingsNav.Top.Groups'

export const SettingsNavTop: React.FC = () => {
  const [, { isAuthorized: isLegacy }] = usePermission(
    LEGACY_APPROVAL_WORKFLOW_MUTATION,
  )

  const settingsGroup = useMemo(
    () => ({
      header: 'layout:nav.settings.security',
      items: isLegacy
        ? [
            loginAndSecuritySection,
            ipAllowListingSection,
            delayedWithdrawalsSection,
            legacyAdminApprovalsSection,
            fraudManagement,
          ]
        : [
            loginAndSecuritySection,
            ipAllowListingSection,
            delayedWithdrawalsSection,
            approvalSettingsSection,
            fraudManagement,
          ],
    }),
    [isLegacy],
  )

  return (
    <ScrollArea className="h-full" autoHide>
      <MainNav.Groups groups={[...groups, settingsGroup]} />
    </ScrollArea>
  )
}
